export const WORKSPACE_FILTER_KEYS = {
  TYPE: 'type',
  STAGE: 'stage',
};

export const TAB_NAME_PATH_MAP = {
  opportunities: 'PENDO-TAB-OPPORTUNITIES',
  'bench-reminders': 'bench-reminders',
  'talent-feedback': 'PENDO-TAB-TALENT-FEEDBACK',
  interviews: 'PENDO-TAB-INTERVIEWS',
} as const;
